import {
    SET_CURRENT_PROJECT
} from "../constans";

const initState =  {
    project: null
};

const currentProjectReducer = (state = initState, { type, payload }) => {
    switch (type) {
        case SET_CURRENT_PROJECT:
            return {
                ...state,
                project : {...payload}
            };
        default:
            return state;
    }
};
export default currentProjectReducer;
